// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.red-title[data-v-2e7e98e7] {\n  background-color: rgb(204, 33, 40) !important;\n  color: white !important;\n}\n.section-title[data-v-2e7e98e7] {\n  font-size: 24px;\n  font-weight: normal;\n  color: #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
